import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d1c0881"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__input-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "form__text-input-wrapper" }
const _hoisted_4 = ["placeholder", "id", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "form__label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: "text",
        class: _normalizeClass(["form__input", _ctx.getValidationClass]),
        placeholder: _ctx.placeholder,
        id: _ctx.id,
        value: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        ref: "reference"
      }, null, 42, _hoisted_4),
      (_ctx.validationError === 'valid')
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: ['fas', 'check-circle'],
            class: "form__input-validation-icon form__input-validation-icon--valid"
          }))
        : _createCommentVNode("", true),
      (_ctx.validationError === 'invalid')
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 1,
            icon: ['fas', 'exclamation-circle'],
            class: "form__input-validation-icon form__input-validation-icon--invalid"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}